<template>
   <div class="contact-hint">
      <h2>Didn't find the answers you were looking for?</h2>
      <button class="fa-btn fa-btn-primary fa-btn-cta mail-icon" @click="uiStore.setModalType(ModalTypes.CONTACT)">Contact us!</button>
      <div class="disclaimer-container">
        <p class="disclaimer-text">
          <strong v-if="!onlyText">Info:</strong> Contact us and we'll get back to you within one business day.
        </p>
      </div>
    </div>
</template>

<script setup>
import { ModalTypes } from '@/types/enums';
import { useUIStore } from '@/store/uiStore';

const uiStore = useUIStore();
</script>